import { Button } from "@/components/ui/button";
import { Plus } from "lucide-react";
import { Step } from "../types";
import { SequenceStep } from "../SequenceStep";

interface SequenceStepsListProps {
  steps: Step[];
  onRemoveStep: (index: number) => void;
  onUpdateStep: (index: number, field: string, value: any) => void;
  onAddStep: () => void;
  isSaving: boolean;
}

export const SequenceStepsList = ({
  steps,
  onRemoveStep,
  onUpdateStep,
  onAddStep,
  isSaving
}: SequenceStepsListProps) => {
  return (
    <div className="space-y-4">
      {steps.map((step, index) => (
        <SequenceStep
          key={index}
          step={step}
          onRemove={() => onRemoveStep(index)}
          onUpdate={(field, value) => onUpdateStep(index, field, value)}
        />
      ))}
      <Button 
        onClick={onAddStep} 
        className="w-full flex items-center gap-2"
        disabled={isSaving}
      >
        <Plus className="h-4 w-4" />
        Add Step
      </Button>
    </div>
  );
};